import styled from "styled-components";

export const GlobalWrapper = styled.div`
  position: relative;
  width: 100%;
`;
